<template>

  <v-container fluid fill-height ma-0 pa-0>

    <v-layout column fill-height  ma-0 pa-0 pt-0 >

      <v-flex shrink pa-0>

      </v-flex>

      <v-layout shrink  row fill-height style="height: 100%" my-0 pa-0 pt-0>

        <v-layout v-show="showCabinet" class="active" row shrink fill-height style="height: 100%; position: relative" ma-0 pa-0>

          <v-flex shrink :style="`position: relative; min-width: ${getCurrentCabinet.width * 0.4}px; overflow-y: auto; overflow-x: hidden;`"  mr-0 pa-3>

            <v-layout column @click.stop="" ref="cabinetFront" ma-0 pa-0 >
              <v-layout justify-space-around shrink pb-3>

                <v-btn :color="sideView == 'front' ? 'primary' : 'secondary'" small outline dark 
                  :data-testid="$options.name + '__btn__' + 'mount_front'"
                  @click="sideView = 'front'">
                  {{$t('mount_front')}}
                </v-btn>
                <v-btn :color="sideView != 'front' ? 'primary' : 'secondary'" small outline dark 
                  :data-testid="$options.name + '__btn__' + 'mount_rear'"
                  @click="sideView = 'rear'">
                  {{$t('mount_rear')}}
                </v-btn>

              </v-layout>
              <v-layout justify-space-around shrink>
                <component
                  is="cabinet"
                  :mount="sideView"
                  :data="getCurrentCabinet"
                  @addDevice="(payload) => onDeviceAdd(payload)"
                  @closed="(payload) => {this.closedUnits = payload}"
                />
              </v-layout>

            </v-layout>

          </v-flex>

        </v-layout>

        <v-layout ref="barWrapper" style="position: relative" ml-2>

          <cabinet-show
            v-if="getCurrentCabinet.$id"
            :cabinet="getCurrentCabinet"
            :closedUnits="getClosedUnits"
            @showCabinet="(payload) => onCabinetShow(payload)"
            @edit="() => onBarOpen('cabinet')"
          />

          <device-bar
            :open="getDeviceBarOpen"
            :size="getBarSize"
            :cabinet="getCurrentCabinet"
            :cabinetShow="showCabinet"
            :closedUnits="getClosedUnits"
            :selectedSlot="getSelectedSlot"
            @update="(payload) => onDeviceUpdate(payload)"
            @showCabinet="(payload) => onCabinetShow(payload)"
            @load-devices="()=>loadDevices()"
            @close="() => onDeviceBarClose()"
          />

          <cabinet-bar
            :open="getCabinetBarOpen"
            :size="getBarSize"
            :data="getCurrentCabinet"
            :closedUnits="getClosedUnits"
            @update="(payload) => onCabinetUpdate(payload)"
            @close="() => onCabinetBarClose()"
          />
        </v-layout>

      </v-layout>

    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import Cabinet from '@/nms/components/cabinet/cabinet.vue'
import DeviceBar from '@/nms/pages/device/device-bar.vue'
import CabinetShow from '@/nms/pages/cabinet/cabinet-show.vue'
import CabinetBar from '@/nms/pages/cabinet/cabinet-bar.vue'
import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas'
import 'jspdf-autotable'
import myFont from '@/nms/assets/RobotoCondensed-Regular-normal.js'
import { mapGetters } from 'vuex'

// Типы
interface CabinetData {
  $id?: string
  id?: string
  name?: string
  cls?: string
  usize?: number
  width?: number
  height?: number
  namePath?: string
  children?: any[]
  [key: string]: any
}

interface SelectedSlot {
  mount: string | null
  position: number | null
  closed: any[]
}

interface BarState {
  device: { open: boolean }
  cabinet: { open: boolean }
}

interface CurrentState {
  cabinet: CabinetData
}

interface DeviceItem {
  $id?: string
  id?: string
  name?: string
  cls?: string
  position?: number
  serial_number?: string
  refs?: Array<{ cls?: string; number?: string; [key: string]: any }>
  children?: DeviceItem[]
  [key: string]: any
}

interface ProjectRef {
  cls?: string
  number?: string
  [key: string]: any
}

interface PDFColumn {
  title: string
  value: string
  dataKey: string
  type: string
  width: string
}

interface CabinetRow {
  usize: number
  busy_units: number
  available_units: number
}

interface DeviceRow {
  position?: number
  name?: string
  cls?: string
  serial_number?: string
  project_number?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'PAGE_CABINET',

  components: {
    Cabinet,
    DeviceBar,
    CabinetShow,
    CabinetBar,
  },

  props: {},

  data(): {
    crumbs: any[]
    sideView: string
    sides: {
      front: string
      side: string
      rear: string
    }
    showCabinet: boolean
    showFront: boolean
    showRear: boolean
    bar: BarState
    selectedSlot: SelectedSlot
    closedUnits: any[] | null
    current: CurrentState
  } {
    return {
      crumbs: [],
      sideView: 'front',
      sides: {
        front: 'front',
        side: 'side',
        rear: 'rear'
      },
      showCabinet: true,
      showFront: true,
      showRear: false,
      bar: {
        device: { open: false },
        cabinet: { open: false }
      },
      selectedSlot: {
        mount: null,
        position: null,
        closed: [],
      },
      closedUnits: null,
      current: {
        cabinet: {}
      },
    }
  },

  computed: {
    getCrumbs(): any[] {
      return this.crumbs
    },

    getCurrentCabinet(): CabinetData {
      return this.current.cabinet
    },

    getActiveCabinet(): any {
      return this.$store.getters.getActiveCabinet
    },

    getCabinetBarOpen(): boolean {
      return this.bar.cabinet.open
    },

    getDeviceBarOpen(): boolean {
      return this.bar.device.open
    },

    getClosedUnits(): any[] {
      return this.closedUnits || []
    },

    getSelectedSlot(): SelectedSlot {
      return this.selectedSlot
    },

    getBarSize(): number {
      return this.showRear ? 1000 : 1250
    },

    ...mapGetters(['checkPage', 'getTreeActive']),
  },

  watch: {
    '$store.state.devices.devices': {
      handler(newVal: any[]): void {
        this.showFront = false
        const devices = newVal?.length ? this.$merge([], newVal) : []
        this.$set(this.current.cabinet, 'children', devices)
        this.showFront = true
        this.$store.dispatch('setEditMode', false)
      },
      deep: true
    },
    '$store.state.devices.activeCabinet': {
      handler(newVal: CabinetData | null): void {
        this.$set(this.bar.cabinet, 'open', false)
        if (!newVal) return
        this.$store.dispatch('setEditMode', false)
        this.showRear = false
        this.setup('WATCH activeCabinet')
      },
      deep: true
    },
    '$store.state.devices.treeActive': {
      handler(newVal: any[]): void {
        if (!newVal) return
        this.setup('WATCH treeActive')
      },
      deep: true
    },
    '$store.state.devices.sidebar.active': {
      handler(newVal: string): void {
        if (newVal !== 'cabinet') {
          this.$bridge.offStream('cabinet')
        }
      },
      deep: true
    },
    'bar.device.open': {
      handler(newVal: boolean): void {
        if (!newVal) {
          this.showCabinet = true
        }
      },
      deep: true
    },
    'bar.cabinet.open': {
      handler(newVal: boolean): void {
        if (!newVal && this.getCurrentCabinet.$id) {
          this.disposeLock(this.getCurrentCabinet.$id)
        }
      },
      deep: true
    },
    '$store.state.devices.activeDevice': {
      handler(newVal: DeviceItem | null): void {
        if (!newVal) {
          this.$set(this.bar.device, 'open', false)
          return
        }
        this.$set(this.bar.device, 'open', Object.keys(newVal).length !== 0)
        if (this.bar.device.open) {
          this.selectedSlot = newVal as unknown as SelectedSlot
          this.$set(this.bar.cabinet, 'open', false)
        } else {
          this.selectedSlot = {
            mount: null,
            position: null,
            closed: [],
          }
        }
      },
      deep: true
    },
  },

  created(): void {
    this.setup('created')
  },

  methods: {
    async disposeLock($id: string): Promise<void> {
      await this.$store.dispatch('disposeDabLock', $id)
    },

    async PDFReport(): Promise<void> {
      const columnsCabinetRaw: PDFColumn[] = [
        {
          title: 'usize',
          value: 'usize',
          dataKey: 'usize',
          type: 'text',
          width: '20%'
        },
        {
          title: 'busy units',
          value: 'busy_units',
          dataKey: 'busy_units',
          type: 'text',
          width: '20%'
        },
        {
          title: 'available units',
          value: 'available_units',
          dataKey: 'available_units',
          type: 'text',
          width: '20%'
        },
      ]

      const columnsCabinet = columnsCabinetRaw.map(col => ({
        ...col,
        title: this.$getTranslate(col.title)
      }))

      const rowsCabinet: CabinetRow[] = [
        {
          usize: this.current.cabinet.usize || 0,
          busy_units: this.getClosedUnits.length,
          available_units: (this.current.cabinet.usize || 0) - this.getClosedUnits.length,
        }
      ]

      const columnsDevicesRaw: PDFColumn[] = [
        {
          title: 'position',
          value: 'position',
          dataKey: 'position',
          type: 'text',
          width: '20%'
        },
        {
          title: 'name',
          value: 'name',
          dataKey: 'name',
          type: 'text',
          width: '20%'
        },
        {
          title: 'device/module',
          value: 'cls',
          dataKey: 'cls',
          type: 'text',
          width: '20%'
        },
        {
          title: 'serial number',
          value: 'serial_number',
          dataKey: 'serial_number',
          type: 'text',
          width: '20%'
        },
        {
          title: 'project number',
          value: 'project_number',
          dataKey: 'project_number',
          type: 'text',
          width: '20%'
        },
      ]

      const columnsDevices = columnsDevicesRaw.map(col => ({
        ...col,
        title: this.$getTranslate(col.title)
      }))

      const rowsDevices = this.createHeap(this.current.cabinet.children)

      const containerFront = this.$refs['cabinetFront'] as HTMLElement
      const containerRear = this.$refs['cabinetRear'] as HTMLElement
      const cabinetWidth = this.getCurrentCabinet.width || 1000

      const captureOptions = {
        async: true,
        width: 1000,
        height: 1400,
        scale: 1,
        useCORS: true,
        allowTaint: true,
      }

      const canvasFront = await html2canvas(containerFront, captureOptions)
      const resFront = canvasFront.toDataURL('image/png', 1)

      const canvasRear = await html2canvas(containerRear, captureOptions)
      const resRear = canvasRear.toDataURL('image/png', 1)

      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: 'a4'
      })

      doc.addFileToVFS('RobotoCondensed-Regular.ttf', myFont)
      doc.addFont('RobotoCondensed-Regular.ttf', 'MyFont', 'normal')
      doc.setFont('MyFont')

      const path = (this.current.cabinet.namePath?.split('/').slice(2).join('/')) || ''
      doc.setFontSize(10).text(path, 36, 36)
      doc.setLineWidth(0.01).line(16, 40, 430, 40)

      doc.addImage(resFront, 'png', 16, 48)
      doc.addImage(resRear, 'png', cabinetWidth / 3 - 24, 48)

      doc.autoTable({
        styles: { font: 'MyFont' as any },
        alternateRowStyles: { fontSize: 10 },
        columns: columnsCabinet,
        body: rowsCabinet,
        startY: doc.getPageHeight() - 70,
        margin: { left: 16 },
      })

      doc.addPage('a4', 'portrait')
      doc.autoTable({
        styles: { font: 'MyFont' as any },
        alternateRowStyles: { fontSize: 10 },
        columns: columnsDevices,
        body: rowsDevices,
        startY: 24,
        margin: { left: 16 },
        didParseCell: (data) => {
          if (data.row.raw?.cls === 'device') {
            data.cell.styles.fillColor = [40, 170, 100]
          }
        },
      })

      doc.setFontSize(9).setTextColor(101, 101, 101).text(
        `${this.$getTranslate('this report was generated on')} ${(this as any).$moment().format('DD MM YYYY HH:mm')} / ${this.$store.state.auth.user?.login}`,
        10,
        doc.internal.pageSize.height - 10
      )

      for (let i = 1; i <= doc.internal.getNumberOfPages(); i++) {
        doc.setPage(i)
        doc.setFontSize(10)
        doc.setTextColor(88, 88, 88)
        doc.text(
          doc.internal.pageSize.width - 24,
          doc.internal.pageSize.height - 8,
          String(i)
        )
      }

      doc.save(`${this.current.cabinet.name}_report.pdf`)
    },

    createHeap(arr: DeviceItem[] | undefined): DeviceRow[] {
      if (!arr?.length) return []

      const heap: DeviceRow[] = []
      const traverse = (items: DeviceItem[]) => {
        items.forEach(child => {
          if (child.refs?.length) {
            const project = child.refs.find(ref => ref.cls === 'project') as ProjectRef | undefined
            if (project?.number) {
              child.project_number = project.number
            }
          }
          if (child.cls === 'device' || child.cls === 'module') {
            heap.push({
              position: child.position,
              name: child.name,
              cls: child.cls,
              serial_number: child.serial_number,
              project_number: child.project_number,
            })
          }
          if (child.children?.length) {
            traverse(child.children)
          }
        })
      }
      traverse(arr)
      console.log('heap', heap)
      return heap
    },

    onShowRear(): void {
      this.showRear = !this.showRear
    },

    async setup(caller?: string): Promise<void> {
      this.showFront = false

      const activeCabinet = this.getActiveCabinet
      const treeActive = this.getTreeActive

      if (activeCabinet || treeActive) {
        const cabinet = activeCabinet || treeActive
        this.$set(this.current, 'cabinet', this.$merge({}, cabinet))
        this.crumbs = await this.$createCrumbs(this.getTreeActive)
      }

      if (this.current.cabinet.id) {
        this.loadDevices()
      }
    },

    onCabinetShow(payload: boolean): void {
      this.showCabinet = payload
    },

    async onCabinetUpdate(payload?: CabinetData): Promise<void> {
      // console.log('ONCABINETUPDATE')
      try {
        const obj = payload || this.$store.state.devices.treeActive[0]
        if(obj && obj.cls == 'folder') {
          // console.log('ONCABINETUPDATE folder')
          await this.$store.dispatch('activeCabinet', null)
          await this.$store.dispatch('currentActiveTree', null)
          // console.log('ONCABINETUPDATE activeCabinet')
          this.$store.dispatch('loadTree')
          // console.log('ONCABINETUPDATE loadTree')
          await this.$store.dispatch('pageChange', 'objects')
          // console.log('ONCABINETUPDATE pageChange')
          await this.$router.push({ name: 'objects' })
          // console.log('ONCABINETUPDATE $router.push')
        }
        else {
          await this.$store.dispatch('activeCabinet', obj)
          await this.$store.dispatch('disposeDabLock', obj?.$id)
          this.$store.dispatch('loadChildren', obj)
          
        }
        this.$set(this.bar.cabinet, 'open', false)
        this.$store.dispatch('setEditMode', false)
      } catch (err) {
        console.error('CATCH', 'CABINET', 'onCabinetUpdate', err)
      }
    },

    async onDeviceBarClose(): Promise<void> {
      this.$store.dispatch('activeDevice', null)
      this.$store.dispatch('setEditMode', false)
    },

    async onCabinetBarClose(): Promise<void> {
      try {
        await this.$store.dispatch('disposeDabLock', this.getCurrentCabinet.$id)
        this.$set(this.bar.cabinet, 'open', false)
        this.$store.dispatch('setEditMode', false)
      } catch (err) {
        console.error('CATCH', 'CABINET', 'onCabinetBarClose', err)
      }
    },

    onDeviceAdd(payload: any): void {
      if (!payload) return
      this.$store.dispatch('activeDevice', null)
      this.$set(this.selectedSlot, 'mount', payload.side)
      this.$set(this.selectedSlot, 'position', payload.id)
      this.$set(this.selectedSlot, 'closed', payload.closed)
    },

    onDeviceUpdate(payload: DeviceItem): void {
      console.log(this.$options.name, 'onDeviceUpdate', payload)
      this.$store.dispatch('activeDevice', payload)
      this.$store.dispatch('selectItem', payload)
      this.loadDevices()
    },

    async onBarOpen(val: string): Promise<void> {
      try {
        if (this.bar.cabinet.open) {
          await this.$store.dispatch('disposeDabLock', this.getCurrentCabinet.$id)
          this.$set(this.bar.cabinet, 'open', false)
          this.$store.dispatch('setEditMode', false)
          return
        }
        const block = await this.$store.dispatch('createDabLock', this.getCurrentCabinet.$id)
        if (block?.ok) {
          this.$set(this.bar.cabinet, 'open', false)
          this.$set(this.bar.device, 'open', false)
          this.$set(this.bar[val as keyof BarState], 'open', true)
        } else {
          this.$errorHandler(block, 'DabLock')
        }
      } catch (err) {
        console.error('CATCH', 'LOCATION', 'onLocationEdit', err)
      }
    },

    async loadDevices(): Promise<void> {
      try {
        this.setLoader('loadDevices', true)
        const obj = await this.$bridge.getObjectById(this.getCurrentCabinet.$id)
        if (obj) {
          this.$store.dispatch('loadDevices', obj)
        }
        this.setLoader('loadDevices', false)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadDevices', 'error', err)
        this.setLoader('loadDevices', false)
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },
  },
})
</script>

<style lang="css" scoped>
</style>
